export function startsWith(fullString, searchString) {
  return fullString?.substr(0, searchString?.length) === searchString;
}

export const getModifiedContractName = (contractName, orderEntryData) => {
  if (!contractName || typeof contractName !== "string") {
    return contractName;
  }
  let sourceString = "";
  sourceString = orderEntryData?.c || "";
  if (!sourceString) {
    return contractName;
  }
  try {
    const wordsToRemove = sourceString?.split(/\s+/);
    let modifiedName = contractName;
    wordsToRemove?.forEach((word) => {
      const safeWord = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      let pattern;
      if (/\w/.test(word)) {
        pattern = `\\b${safeWord}\\b`;
      } else {
        pattern = `(?<=^|\\s)${safeWord}(?=\\s|$)`;
      }
      const regex = new RegExp(pattern, "gi");
      modifiedName = modifiedName?.replace(regex, "");
    });
    return modifiedName?.replace(/\s+/g, " ")?.trim();
  } catch (error) {
    return contractName + " " + sourceString;
  }
};

export function getLastTwoWords(text) {
  const words = text?.split(" ");
  return words?.slice(-2)?.join(" ");
}

export const getModifiedContractNameFromOrder = (
  contractName,
  tradingOrderDetailsData,
) => {
  if (!contractName || typeof contractName !== "string") {
    return contractName;
  }
  if (!tradingOrderDetailsData || !tradingOrderDetailsData?.length) {
    return contractName;
  }
  const order = tradingOrderDetailsData[0];
  const part1 = order?.p || "";
  const part2 = order?.d || "";
  const sourceString = `${part1} ${part2}`?.trim();

  if (!sourceString) {
    return contractName;
  }
  try {
    const wordsToRemove = sourceString?.split(/\s+/);
    let modifiedName = contractName;
    wordsToRemove?.forEach((word) => {
      const safeWord = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      let pattern;
      if (/\w/.test(word)) {
        pattern = `\\b${safeWord}\\b`;
      } else {
        pattern = `(?<=^|\\s)${safeWord}(?=\\s|$)`;
      }
      const regex = new RegExp(pattern, "gi");
      modifiedName = modifiedName?.replace(regex, "");
    });
    return modifiedName?.replace(/\s+/g, " ")?.trim();
  } catch (error) {
    return contractName + " " + sourceString;
  }
};

export const getModifiedContractNameFromOrder2 = (
  contractName,
  tradingOrderDetailsData,
) => {
  // Basic validation for the first parameter
  if (!contractName || typeof contractName !== "string") {
    return contractName;
  }

  // Handle cases where data is null or an empty array
  if (
    !tradingOrderDetailsData ||
    (Array.isArray(tradingOrderDetailsData) && !tradingOrderDetailsData.length)
  ) {
    return contractName;
  }

  // Determine if we are dealing with an array or a single object
  const order = Array.isArray(tradingOrderDetailsData)
    ? tradingOrderDetailsData[0]
    : tradingOrderDetailsData;

  /* In your second data structure, the 'c' field contains the 
     string to be removed (e.g., "ZS Aug26").
  */
  const sourceString = order?.c?.trim() || "";

  if (!sourceString) {
    return contractName;
  }

  try {
    // Split the source string into individual words/tokens
    const wordsToRemove = sourceString.split(/\s+/);
    let modifiedName = contractName;

    wordsToRemove.forEach((word) => {
      // Escape special characters for Regex safety
      const safeWord = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

      let pattern;
      // If the word contains alphanumeric characters, use word boundaries
      if (/\w/.test(word)) {
        pattern = `\\b${safeWord}\\b`;
      } else {
        // Otherwise, ensure it is surrounded by whitespace or start/end of string
        pattern = `(?<=^|\\s)${safeWord}(?=\\s|$)`;
      }

      const regex = new RegExp(pattern, "gi");
      modifiedName = modifiedName.replace(regex, "");
    });

    // Clean up extra spaces left behind and return
    return modifiedName.replace(/\s+/g, " ").trim();
  } catch (error) {
    // Fallback in case of regex failure
    return contractName + " " + sourceString;
  }
};

export const tradingGridGroupGetter = (data, id) => {
  return data?.find((elem) => elem?.id === id);
};
